import { ArtistInvite, Claim } from './page/Claim.jsx';
import Footer from './marketing/Footer.jsx';;
import InvoiceConfirmation from './page/InvoiceConfirmation.jsx';
import Navigation from './marketing/Navigation.jsx';
import { Onboarding } from './page/Onboarding.jsx';
import Onboarding2 from './page/Onboarding2.jsx';
import PasswordReset from './page/PasswordReset.jsx';


export default {
    ArtistInvite,
    Claim,
    Footer,
    InvoiceConfirmation,
    Navigation,
    Onboarding,
    Onboarding2,
    PasswordReset
};